// A board is finished when it has at least one task and every task is completed or postponed
export const evaluateBoard = (slots) => {
    let count = 0;
    let postponed = 0;
    let finished = true;
    let startedAt = null;
    for (const slot of slots) {
        if (slot.isEmpty()) {
            continue;
        }
        ++count;
        if (slot.status === 'postponed') {
            ++postponed;
        }
        else if (!slot.isComplete()) {
            finished = false;
        }
        if (slot.added != null && (startedAt == null || slot.added < startedAt)) {
            startedAt = slot.added;
        }
    }
    return { finished: finished && count > 0, postponed, count, startedAt };
};
